// 9fbef606107a605d69c0edbcd8029e5d
/**
 * Common timer names used for measuring the performance
 * of key elements and interactions. These strings may
 * be configured in mPulse as custom timer values.
 *
 * @see https://childrensplace.atlassian.net/wiki/spaces/RDP/pages/797705180/Page-wise+measures+for+mPulse
 * @see https://community.akamai.com/customers/s/article/mPulse-Custom-and-Navigation-Timers
 */

// The time when the last (client-side) navigation change began
export const NAVIGATION_START = 'navigation_start';

// The time when the primary page content is considered completely visible to the end-user
export const FULLY_VISIBLE = 'fully_visible';

// The time when the primary visual media element is considered visible to the end-user
export const HERO_VISIBLE = 'hero_visible';

// The time when the primary call to action (such as a button) is considered visible to the end-user
export const CALL_TO_ACTION_VISIBLE = 'call_to_action_visible';

// The time when the primary navigation element is considered visible to the end-user
export const NAVIGATION_VISIBLE = 'navigation_visible';

// The time when the primary heading is considered visible to the end-user
export const HEADING_VISIBLE = 'heading_visible';

// The time when the primary pricing content is considered visible to the end-user
export const PRICING_VISIBLE = 'pricing_visible';

// The time when the primary control elements (such as size or color options) are considered visible to the end-user
export const CONTROLS_VISIBLE = 'controls_visible';

// The time when the primary list of results (such as a product listing) are considered visible to the end-user
export const RESULTS_VISIBLE = 'results_visible';

// The time when the primary promotional content (such as banners) are considered visible to the end-user
export const PROMOTION_VISIBLE = 'promotion_visible';

// The time when the primary (page-level) navigation element is considered visible to the end-user
export const PAGE_NAVIGATION_VISIBLE = 'page_navigation_visible';

// The time when the primary global branding element is considered visible to the end-user
export const BRAND_IDENTITY_VISIBLE = 'brand_identity_visible';

export const HOME_PAGE_URL = 'home';

export const SINGLE_TEXT = 'single';

export const SPC_TIMER = 'SPCTimer';

export const SPC_CUSTOM_DIMENSION_GROUP = 'CheckoutGroup';

// The time when the product details component is considered visible to the end-user
export const PRODUCT_DETAILS_VISIBLE = 'mark_prod_details_visible';

// The time when the order leger component is considered visible to the end-user
export const ORDER_LEDGER_VISIBLE = 'mark_order_ledger_visible';

// The time when the shipping form component is considered visible to the end-user
export const SHIPPING_FORM_VISIBLE = 'mark_shipping_form_visible';

// The time when the shipping form component is considered visible to the end-user
export const BILLING_FORM_VISIBLE = 'mark_billing_form_visible';

// The time when the submit order button is considered visible to the end-user
export const SUBMIT_ORDER_BUTTON_VISIBLE = 'mark_submit_order_visible';

// The time when the shipping collapsed component is considered visible to the end-user
export const SHIPPING_EXPRESS_FORM_VISIBLE = 'mark_shipping_express_form_visible';

// The time when the billing collapsed component is considered visible to the end-user
export const BILLING_EXPRESS_FORM_VISIBLE = 'mark_billing_express_form_visible';

// The time when the submit express order button is considered visible to the end-user
export const SUBMIT_EXPRESS_ORDER_BUTTON_VISIBLE = 'mark_submit_express_order_visible';

/**
 * This array is used to filter performance entries down to only the custom definitions above
 *
 * @example
 * performance.getEntriesByType("measure")
 *   .filter(entry => TIMER_NAMES.includes(entry.name))
 */
export const TIMER_NAMES = [
  NAVIGATION_START,
  FULLY_VISIBLE,
  HERO_VISIBLE,
  CALL_TO_ACTION_VISIBLE,
  NAVIGATION_VISIBLE,
  HEADING_VISIBLE,
  PRICING_VISIBLE,
  CONTROLS_VISIBLE,
  RESULTS_VISIBLE,
  PROMOTION_VISIBLE,
  PAGE_NAVIGATION_VISIBLE,
  BRAND_IDENTITY_VISIBLE,
  HOME_PAGE_URL,
];
